import React, { useEffect } from 'react';
import ReactGA from 'react-ga';

const GoogleAnalyticsTracker = () => {
  useEffect(() => {
    ReactGA.initialize('G-RG19R6WMV8');  // Remplace par ton ID de suivi
    ReactGA.pageview(window.location.pathname + window.location.search);
  }, []);

  return null;
};

export default GoogleAnalyticsTracker;
